import React from "react";
import {Card, CardActions, CardContent, Button, Typography, Grid} from '@mui/material';
import { tipoReporteVallasYPantalla } from "constantes/globalsStates";
import { reportes } from "constantes/reportes";
import { functions } from "constantes";

const VallasYPantallas = () => {

  const descargarReportesVallasYPantallasDigitales = (tipoReporte) => {
    switch(tipoReporteVallasYPantalla[tipoReporte]){
        case 1: // PANTALLA DIGITAL
            functions.descargarBase64EnPDF(reportes.pantallaDigitalConValoresPromedio, "reporte_pantalla_digital_con_valor_de_promedio.xlsx")
            break;
        case 2: // VALLAS MOVILES
            functions.descargarBase64EnPDF(reportes.reporteVallasMoviles, "reporte_vallas_moviles.xlsx")
            break;
        case 3: // VALLAS FIJAS
            functions.descargarBase64EnPDF(reportes.reporteVallasFijas, "reporte_vallas_fijas.xlsx")
            break;
        default:
            break;
    }
  }

  return (
    <Grid container justifyContent={"space-around"} alignItems={"center"} spacing={2} style={{marginTop: '100px'}}>
       <Grid item xs={12} md={4}>
        <Card  style={{ minWidth: '100%', width: '100%' }}>
           <img src={"/menu/pantalla_digital.png"} alt={"PANTALLA DIGITAL CON VALOR DE PROMEDIO"} style={{ width: 100, height: 100, display: "block", margin: '0 auto'}} />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div" textAlign={"center"}>
              PANTALLA DIGITAL CON VALOR DE PROMEDIO
            </Typography>
          </CardContent>
          <CardActions>
            <div style={{margin: "0 auto"}}>
              <Button variant="contained" color="primary" size="large" onClick={() => descargarReportesVallasYPantallasDigitales("pantalla_digital_con_valor")}>Descargar reporte</Button>
            </div>
          </CardActions>
        </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card  style={{ minWidth: '100%', width: '100%' }}>
            <img src={"/menu/vallas_moviles.png"} alt={"Vallas moviles"} style={{ width: 100, height: 100, display: "block", margin: '0 auto'}} />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div" textAlign={"center"}>
                REPORTES VALLAS MOVILES
              </Typography>
            </CardContent>
            <CardActions>
              <div style={{margin: "0 auto"}}>
                <Button variant="contained" color="primary" size="large" onClick={() => descargarReportesVallasYPantallasDigitales("vallas_moviles")}>Descargar reporte</Button>
              </div>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card  style={{ minWidth: '100%', width: '100%' }}>
            <img src={"/menu/vallas_fijas.png"} alt={"Vallas fijas"} style={{ width: 100, height: 100, display: "block", margin: '0 auto'}} />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div" textAlign={"center"}>
                REPORTE VALLAS FIJAS
              </Typography>
            </CardContent>
            <CardActions>
              <div style={{margin: "0 auto"}}>
                <Button variant="contained" color="primary" size="large" onClick={() => descargarReportesVallasYPantallasDigitales("vallas_fijas")}>Descargar reporte</Button>
              </div>
            </CardActions>
          </Card>
        </Grid>
    </Grid>
  );
}

export default VallasYPantallas; 